import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button } from '../Button'
import { Flex, FlexProps } from '../Flex'
import { Text } from '../Text'
import { themeSpace, ThemeWrapper } from '../theme'

const StyledHeader = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  background: ${({ theme }) => theme.colors.gray};
  height: 72px;
  padding: 0 ${themeSpace(5)};
`
const IconsContainer = styled(Flex)`
  align-items: 'center';
  & > .anticon {
    margin-left: ${({ theme }) => theme.space[2]};
    font-size: 1.5em;
  }

  button {
    padding: 0 16px;
  }
`
export interface LoginAsHeaderProps extends React.PropsWithRef<FlexProps> {
  loggedIn: boolean
  fullName: string
  logout: () => void
}

export const LoginAsHeader = ({ loggedIn, fullName, logout }: LoginAsHeaderProps) => {
  const { t } = useTranslation(['LoginAs'])

  return (
    <ThemeWrapper>
      <StyledHeader>
        <Text color="primary" block>
          {t('Text', { username: fullName })}
        </Text>
        <Flex justifyContent="flex-end">
          <IconsContainer py={2}>
            {loggedIn && (
              <Button variant="primary" iconPlacement="right" onClick={logout}>
                {t('Button')}
              </Button>
            )}
          </IconsContainer>
        </Flex>
      </StyledHeader>
    </ThemeWrapper>
  )
}
